import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { formatDate } from "@angular/common";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { GoogleMap } from "@angular/google-maps";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { CustomerServiceService } from "src/app/customer/customer-service.service";
import { LoginComponent } from "../login/login.component";
import { SharedService } from "../shared.service";
import { DOCUMENT } from "@angular/common";
import { MatSnackBar } from "@angular/material/snack-bar";
import { map, Observable, startWith } from "rxjs";
import { TransporterLoginComponent } from "src/app/truck-owner/transporter-login/transporter-login.component";
import { DeviceDetectionService } from "src/app/device-detection.service";
import { CommonServices } from "src/app/common.services";
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit, OnDestroy {
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  matDialogref: MatDialogRef<LoginComponent> | undefined;
  MatDialogref: MatDialogRef<TransporterLoginComponent>;
  scrollevent: boolean = false;
  mobileToggleEvent: boolean = false;
  coordinatesForm!: FormGroup;
  pickupAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  dropLat: any;
  dropLong: any;
  pickup_long_name: any = "";
  pickup_short_name: any = "";
  dropAutoComplete: any;
  drop_long_name: any = "";
  drop_short_name: any = "";
  completeDropAddress: any;
  completePickUpAddress: any;
  @ViewChild("pickUpLocationSearchField")
  pickUpLocation: ElementRef | any;
  @ViewChild("dropLocationSearchField")
  dropLocation!: ElementRef;
  truckCategory: any = [];
  truckWeight: any = [];
  searchBtn: boolean = true;
  token: any;
  truckDetails: any;
  @ViewChild(GoogleMap) map: GoogleMap | any;
  loginSignup: boolean = true;
  profile: boolean = false;
  profilePic: any;
  userName: any;
  pickup_postal_code: any;
  dropoff_postal_code: any;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  myControl = new FormControl();
  filterWeight: Observable<any[]> | undefined;
  tripSearchData: any;
  search: any;
  userType: any;
  user: any;
  loading: boolean = false;
  locationError: boolean = false;
  locationsMatch: boolean = false;
  showCloseIconPick = false;
  showCloseIconDrop = false;
  dropPlace: any;
  pickupPlace: any;

  availableRoutes: any[] = [];
  showAllRoutes: boolean = false;

  // isAndroidDevice: boolean = false;
  // isLaptopDevice: boolean = false;

  constructor(
    private matDialog: MatDialog,
    private fb: FormBuilder,
    private services: CustomerServiceService,
    private router: Router,
    private shrdSrvce: SharedService,
    private snackBar: MatSnackBar,
    private deviceDetectionService: DeviceDetectionService,
    private commonServices: CommonServices
  ) {
    this.minDate.setDate(this.minDate.getDate() - 0);
    this.maxDate.setDate(this.maxDate.getDate() + 2);
  }

  driverRoutesSubs: any;

  ngOnInit(): void {
    this.GetProfileDetails();
    this.fetchAvailableRoutes();
    this.shrdSrvce.authState$.subscribe(() => {
      this.GetProfileDetails();
    });

    this.driverRoutesSubs = this.commonServices
      .getPublishedEvent("driverRoutes")
      .subscribe((data: any) => {
        this.fetchAvailableRoutes();
      });

    this.coordinatesForm = this.fb.group({
      pickup: [""],
      drop: [""],
      date: [""],
      truck_category: [""],
      truck_type: [""],
    });
    this.GetCategory();

    this.filterWeight = this.myControl.valueChanges.pipe(
      startWith(""),
      map((value: string) => this._filterType(value))
    );
    this.user = sessionStorage.getItem("user_type");

    this.shrdSrvce.currentsearchDetails.subscribe((result: any) => {
      if (result && result.searchData) {
        var SearchTruckDetails = result.searchData;
        this.coordinatesForm.controls["pickup"].setValue(
          `${SearchTruckDetails.completePickUpAddress?.formatted_address || ''}`
        );
        this.coordinatesForm.controls["drop"].setValue(
          `${SearchTruckDetails.completeDropAddress?.formatted_address || ''}`
        );
        this.coordinatesForm.controls["date"].setValue(
          `${SearchTruckDetails.date || ''}`
        );
        this.coordinatesForm.controls["truck_category"].setValue(
          `${SearchTruckDetails.truck_category || ''}`
        );
        // this.pickup_long_name = this.SearchTruckDetails.fromLocation.from_area_name;
        this.pickup_short_name = SearchTruckDetails.fromLocation?.from_city_name || '';
        this.pickup_postal_code = SearchTruckDetails.fromLocation?.from_pincode || '';
        this.pickupLat = SearchTruckDetails.fromLocation?.from_lat || '';
        this.pickupLong = SearchTruckDetails.fromLocation?.from_long || '';
        this.drop_long_name = SearchTruckDetails.toLocation?.to_area_name || '';
        this.drop_short_name = SearchTruckDetails.toLocation?.to_city_name || '';
        this.dropoff_postal_code = SearchTruckDetails.toLocation?.to_pincode || '';
        this.dropLat = SearchTruckDetails.toLocation?.to_lat || '';
        this.dropLong = SearchTruckDetails.toLocation?.to_long || '';
        this.completePickUpAddress = SearchTruckDetails.completePickUpAddress;
        this.completeDropAddress = SearchTruckDetails.completeDropAddress;
        if (SearchTruckDetails && SearchTruckDetails.truck_category && !SearchTruckDetails.selected_route) {
          this.GetTruckWeight();
        }
      } else {
        this.router.navigateByUrl("/");
      }
    });
    this.coordinatesForm.get("pickup")?.valueChanges.subscribe((value) => {
      this.showCloseIconPick = !!value;
      if (!value) {
        this.pickup_long_name = "";
        this.pickup_short_name = "";
        this.pickup_postal_code = "";
        this.pickupLat = "";
        this.pickupLong = "";
        this.completePickUpAddress = null;
        this.pickupPlace = null;
      }
    });
    this.coordinatesForm.get("drop")?.valueChanges.subscribe((value) => {
      this.showCloseIconDrop = !!value;
      if (!value) {
        this.drop_long_name = "";
        this.drop_short_name = "";
        this.dropoff_postal_code = "";
        this.dropLat = "";
        this.dropLong = "";
        this.completeDropAddress = null;
        this.dropPlace = null;
      }
    });
  }

  private _filterType(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.truckWeight
      .map((ele: any) => ({ _id: ele._id, truck_weight: ele.truck_weight }))
      .filter((option: any) => option.truck_weight.length > 0);
  }

  public GetProfileDetails() {
    this.token =
      sessionStorage.getItem("token") || sessionStorage.getItem("corporate_token");
    this.userName =
      sessionStorage.getItem("userName") || sessionStorage.getItem("corporateUserName");
    this.profilePic =
      sessionStorage.getItem("ProfilePic") || sessionStorage.getItem("corporateProfilePic");
    if (this.token) {
      this.profile = true;
      this.loginSignup = false;
    } else {
      this.profile = false;
      this.loginSignup = true;
    }
  }

  ngAfterViewInit(): void {
    var options = {
      // types: ['(cities)'],
      componentRestrictions: { country: "in" },
    };
    this.pickupAutoComplete = new google.maps.places.Autocomplete(
      this.pickUpLocation.nativeElement,
      options
    );
    this.dropAutoComplete = new google.maps.places.Autocomplete(
      this.dropLocation.nativeElement,
      options
    );
    this.onInputPickUpchange();
    this.onDropChange();
  }

  public GetCategory() {
    this.services.GetCategory().subscribe((response: any) => {
        if (response.status === 200) {
            this.truckCategory = response.body.data
                .filter((item: any) => item.truck_category_name)
                .sort((a: any, b: any) => a.truck_category_name.localeCompare(b.truck_category_name));
        }
    });
  }

  public GetTruckWeight() {
    var category = this.coordinatesForm.value.truck_category;
    if (!category) {
      this.truckWeight = [];
      return;
    }
    this.services.GettruckWeight(category).subscribe((response: any) => {
      if (response.status === 200) {
        this.truckWeight = (response.body.data || [])
        .sort((a: any, b: any) => {
          let weightA = parseInt(a.truck_weight);
          let weightB = parseInt(b.truck_weight);
          return weightA - weightB;
        });
        this.filterWeight = this.truckWeight;
        if (this.truckWeight.length === 0) {
          this.snackBar.open("No truck types found for this category", "Fail", {
            duration: 5000,
          });
        }
      }
    });
  }

  login(routeFrom: string, fullResult?: any) {
    this.matDialogref = this.matDialog.open(LoginComponent, {
      width: "500px",
      data: {
        routeFrom: routeFrom,
        tripSearchData: this.tripSearchData,
        fullResult: fullResult,
        truckWeight: this.truckWeight,
        truckCategory: this.truckCategory,
      },
    });
    this.matDialogref.afterClosed().subscribe(() => {
      this.GetProfileDetails();
    });
  }

  GoToProfile() {
    sessionStorage.removeItem("quoteBooked");
    this.userType = sessionStorage.getItem("user_type");
    if (this.userType === "corporate") {
      this.router.navigateByUrl("/corporate/profile");
    } else {
      this.router.navigateByUrl("/profile");
    }
  }

  trips() {
    this.userType = sessionStorage.getItem("user_type");
    if (this.userType === "corporate") {
      this.router.navigateByUrl("/corporate/trips");
    } else {
      this.router.navigateByUrl("/trips");
    }
  }

  loginTransporter() {
    const tokenDummy =
      sessionStorage.getItem("token") ||
      sessionStorage.getItem("corporate_token") ||
      sessionStorage.getItem("to_token");
    if (tokenDummy) {
      // If the token exists (not null, undefined, or an empty string)
      this.snackBar.open("You are already logged in", "Ok", {
        duration: 5000,
      });
      return; // Stop the sendOTP function from proceeding
    }
    this.MatDialogref = this.matDialog.open(TransporterLoginComponent, {
      width: "500px",
    });
    this.MatDialogref.afterClosed().subscribe(() => {
      this.GetProfileDetails();
    });
  }

  Logout() {
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("ProfilePic");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("corporate_token");
    sessionStorage.removeItem("corporateUserName");
    sessionStorage.removeItem("corporateProfilePic");
    sessionStorage.removeItem("corporate_user_type");
    sessionStorage.removeItem("user_type");
    sessionStorage.removeItem("searchData");
    sessionStorage.removeItem("search_details");
    sessionStorage.removeItem("quoteBooked");
    this.shrdSrvce.notifyAuthChange();
    this.GetProfileDetails();
    window.location.reload();
    this.router.navigateByUrl("/");
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      this.scrollevent = true;
    } else {
      this.scrollevent = false;
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    if (event.target.innerWidth > 991) {
      this.mobileToggleEvent = false;
    }
  }

  mobileToggle() {
    this.mobileToggleEvent = !this.mobileToggleEvent;
  }

  onInputPickUpchange() {
    this.geoCodePickUp(this.coordinatesForm.value.pickup);
    this.checkLocations();
  }

  onDropChange() {
    this.geoCodeDrop(this.coordinatesForm.value.drop);
    this.checkLocations();
  }

  numberWith4Decimal(num: any) {
    num = num.toString(); //If it's not already a String
    num = num.slice(0, num.indexOf(".") + 5); //With 3 exposing the hundredths place
    return num; //If you need it back as a Number
  }
  checkLocations() {
    const pickups = this.coordinatesForm.get("pickup")?.value;
    const dropup = this.coordinatesForm.get("drop")?.value;
    if (pickups && dropup && pickups === dropup) {
      return;
    }
  }
  requestQuote() {
    const pickups = this.coordinatesForm.get("pickup")?.value;
    const dropup = this.coordinatesForm.get("drop")?.value;
    if (pickups && dropup && pickups.trim() !== "" && pickups.trim() === dropup.trim()) {
      this.snackBar.open(
        "Pick-up and Drop-off locations should not be the same",
        "Fail",
        { duration: 5000 }
      );
      return;
    }

    if (!this.pickupLat || !this.pickupLong) {
      this.snackBar.open("Please select correct Pick-up location", "Fail", {
        duration: 4000,
      });
      return;
    }

    if (!this.dropLat || !this.dropLong) {
      this.snackBar.open("Please select correct Drop-off location", "Fail", {
        duration: 4000,
      });
      return;
    }

    sessionStorage.removeItem("loadDetails");
    this.token =
      sessionStorage.getItem("token") || sessionStorage.getItem("corporate_token");
    let pick = this.coordinatesForm.value.pickup || "";
    let drop = this.coordinatesForm.value.drop || "";
    let date = this.coordinatesForm.value.date;
    let categ = this.coordinatesForm.value.truck_category || "";
    let type = this.coordinatesForm.value.truck_type || "";

    this.loading = true;

    const fromLoc: any = pick ? {
      from_area_name: this.pickup_long_name || pick,
      from_city_name: this.pickup_short_name || pick,
      from_pincode: Number(this.pickup_postal_code) || 0,
      from_lat: this.pickupLat ? (Math.round(this.pickupLat * 10000) / 10000).toString() : "",
      from_long: this.pickupLong ? (Math.round(this.pickupLong * 10000) / 10000).toString() : "",
    } : {
      from_area_name: "",
      from_city_name: "",
      from_pincode: 0,
      from_lat: "",
      from_long: "",
    };

    const toLoc: any = drop ? {
      to_area_name: this.drop_long_name || drop,
      to_city_name: this.drop_short_name || drop,
      to_pincode: Number(this.dropoff_postal_code) || 0,
      to_lat: this.dropLat ? (Math.round(this.dropLat * 10000) / 10000).toString() : "",
      to_long: this.dropLong ? (Math.round(this.dropLong * 10000) / 10000).toString() : "",
    } : {
      to_area_name: "",
      to_city_name: "",
      to_pincode: 0,
      to_lat: "",
      to_long: "",
    };

    this.tripSearchData = {
      fromLocation: fromLoc,
      toLocation: toLoc,
      date: date ? formatDate(date, "yyyy-MM-dd", "en") : "",
      truck_category: categ,
      truck_type: type,
      completePickUpAddress: pick ? (this.completePickUpAddress || { formatted_address: pick }) : null,
      completeDropAddress: drop ? (this.completeDropAddress || { formatted_address: drop }) : null,
      truckCategory: this.truckCategory,
      truckWeight: this.truckWeight,
    };
    this.loading = false;

    this.searchBtn = true;
    this.tripSearch();
    this.searchBtn = false;
  }

  tripSearch() {
    this.token =
      sessionStorage.getItem("token") || sessionStorage.getItem("corporate_token");
    this.services
      .SearchTruckDetails(this.tripSearchData, this.token)
      .subscribe((response: any) => {
        if (response.status === 201 || response.status === 200) {
          const directData = response.body?.data || [];
          const otherTruckType = response.body?.otherTruckType || [];
          const rawRoutes = [...directData, ...otherTruckType];

          const userTypeForCheck = sessionStorage.getItem("user_type");
          const hasAllDetails = !!(
            this.coordinatesForm.value.pickup &&
            this.coordinatesForm.value.drop &&
            this.coordinatesForm.value.date &&
            this.coordinatesForm.value.truck_category &&
            (userTypeForCheck === "corporate" || this.coordinatesForm.value.truck_type)
          );

          if (rawRoutes.length > 0) {
            this.availableRoutes = rawRoutes.map((item: any) => {
              const fromCity = item.fromLocation?.from_city_name || item.fromLocation?.from_area_name || "Origin";
              const toCity = item.toLocation?.to_city_name || item.toLocation?.to_area_name || "Destination";
              const truckType = item.truck_type_name || (item.truck_weight ? `${item.truck_weight} ${item.truck_feet || ''}`.trim() : '') || item.make_name || "Truck";
              const truckCategory = item.truck_category_name || (item.truck_category === 'open' ? 'Open Truck' : 'Container') || 'Truck';
              const priceVal = item.price ?? item.route_fare ?? item.total_fare ?? 0;

              return {
                ...item,
                from: fromCity,
                to: toCity,
                truck_type_name: truckType,
                truck_category_name: truckCategory,
                available_trucks: item.available_trucks || 1,
                price: priceVal,
                driver_route_unique_id: item.driver_route_unique_id
              };
            });
          } else {
            this.availableRoutes = [];
            if (!hasAllDetails) {
              this.snackBar.open("Please fill all the details to get a quote", "Ok", { duration: 4000 });
            }
          }

          this.truckDetails = directData.length > 0 ? directData : otherTruckType;

          this.tripSearchData["truckweight"] = this.truckWeight.find(
            (ele: any) => {
              return ele._id === this.coordinatesForm.value.truck_type;
            }
          ) || null;
          this.tripSearchData["truckDetails"] = this.truckDetails;
          this.tripSearchData["truckCategory"] = {
            id: this.coordinatesForm.value.truck_category || "",
            name: this.truckCategory.find((ele: any) => {
              if (ele._id === this.coordinatesForm.value.truck_category) {
                return ele.truck_category_name;
              }
            })?.truck_category_name || "",
          };
          this.tripSearchData["completePickUpAddress"] =
            this.completePickUpAddress || { formatted_address: this.coordinatesForm.value.pickup || "" };
          this.tripSearchData["completeDropAddress"] =
            this.completeDropAddress || { formatted_address: this.coordinatesForm.value.drop || "" };
          this.tripSearchData["dropPlace"] = this.dropPlace || null;
          this.tripSearchData["pickupPlace"] = this.pickupPlace || null;
          sessionStorage.setItem(
            "searchData",
            JSON.stringify(this.tripSearchData)
          );

          if (hasAllDetails) {
            const searchdata = {
              searchData: this.tripSearchData,
              data: directData,
              otherTruckType: otherTruckType,
              truckweight: this.tripSearchData["truckweight"],
              truckCategory: this.tripSearchData["truckCategory"],
            };
            if (!this.token) {
              this.login("ReserveTrip", searchdata);
            } else {
              this.shrdSrvce.updateSearchDetails(searchdata);
              if (userTypeForCheck === "corporate") {
                this.router.navigateByUrl("/corporate/create-work-order");
              } else {
                this.router.navigateByUrl("/truck-details");
              }
            }
          }
        }
      });
  }
  geoCodePickUp(address: any) {
    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        this.pickupPlace = place;
        geoCoder.geocode(
          {
            address: place.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.pickupLat = results[0].geometry.location.lat();
              this.pickupLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.pickupLat,
                this.pickupLong
              );
              this.autoCompletePickupGeoCode(geoCoder, latlong);

              this.coordinatesForm.controls["pickup"].setValue(
                place.formatted_address
              );
              this.checkLocations();
            }
          }
        );
      }
    );
  }
  autoCompletePickupGeoCode(geoCoder: any, latlong: any) {
    geoCoder.geocode({ location: latlong }, (result: any) => {
      this.completePickUpAddress = result[0];
      for (
        let i = 0;
        i < this.completePickUpAddress.address_components.length;
        i++
      ) {
        if (
          this.completePickUpAddress.address_components[i].types[0] ==
            "locality" &&
          this.completePickUpAddress.address_components[i].types[1] ==
            "political"
        ) {
        }
        if (
          this.completePickUpAddress.address_components[i].types[0] ==
            "political" &&
          this.completePickUpAddress.address_components[i].types[1] ==
            "sublocality" &&
          this.completePickUpAddress.address_components[i].types[2] ==
            "sublocality_level_1"
        ) {
          this.pickup_long_name =
            this.completePickUpAddress.address_components[i].long_name;
        }
        if (
          this.completePickUpAddress.address_components[i].types[0] ==
          "postal_code"
        ) {
        }
        if (this.pickup_short_name && this.pickup_long_name) {
        }
      }
    });
  }

  geoCodeDrop(address: any) {
    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const dropPlace = this.dropAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        this.dropPlace = dropPlace;

        geoCoder.geocode(
          {
            address: dropPlace.formatted_address,
          },

          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.dropLat = results[0].geometry.location.lat();
              this.dropLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.dropLat,
                this.dropLong
              );
              this.autoCompleteDropGeoCode(geoCoder, latlong);

              this.coordinatesForm.controls["drop"].setValue(
                dropPlace.formatted_address
              );
              this.checkLocations();
            }
          }
        );
      }
    );
  }
  autoCompleteDropGeoCode(geoCoder: any, latlong: any) {
    geoCoder.geocode({ location: latlong }, (result: any) => {
      this.completeDropAddress = result[0];
      for (
        let i = 0;
        i < this.completeDropAddress.address_components.length;
        i++
      ) {
        if (
          this.completeDropAddress.address_components[i].types[0] ==
            "locality" &&
          this.completeDropAddress.address_components[i].types[1] == "political"
        ) {
          this.drop_short_name =
            this.completeDropAddress.address_components[i].long_name;
        }
        if (
          this.completeDropAddress.address_components[i].types[0] ==
            "political" &&
          this.completeDropAddress.address_components[i].types[1] ==
            "sublocality" &&
          this.completeDropAddress.address_components[i].types[2] ==
            "sublocality_level_1"
        ) {
          this.drop_long_name =
            this.completeDropAddress.address_components[i].long_name;
        }
        if (
          this.completeDropAddress.address_components[i].types[0] ==
          "postal_code"
        ) {
        }
      }
    });
  }
  clearPickField() {
    this.coordinatesForm.get("pickup")?.setValue("");
    this.coordinatesForm.get("pickup")?.updateValueAndValidity();
    this.showCloseIconPick = false;
    this.pickup_long_name = "";
    this.pickup_short_name = "";
    this.pickup_postal_code = "";
    this.pickupLat = "";
    this.pickupLong = "";
    this.completePickUpAddress = null;
    this.pickupPlace = null;
    if (this.pickUpLocation?.nativeElement) {
      this.pickUpLocation.nativeElement.value = "";
    }
    this.checkLocations();
  }
  clearDropField() {
    this.coordinatesForm.get("drop")?.setValue("");
    this.coordinatesForm.get("drop")?.updateValueAndValidity();
    this.showCloseIconDrop = false;
    this.drop_long_name = "";
    this.drop_short_name = "";
    this.dropoff_postal_code = "";
    this.dropLat = "";
    this.dropLong = "";
    this.completeDropAddress = null;
    this.dropPlace = null;
    if (this.dropLocation?.nativeElement) {
      this.dropLocation.nativeElement.value = "";
    }
    this.checkLocations();
  }

  ngOnDestroy(): void {
    if (this.driverRoutesSubs) {
      this.driverRoutesSubs.unsubscribe();
    }
  }

  fetchAvailableRoutes() {
    const payload = {
      fromLocation: { from_area_name: "", from_city_name: "", from_lat: "", from_long: "" },
      toLocation: { to_area_name: "", to_city_name: "", to_lat: "", to_long: "" },
      date: formatDate(new Date(), "yyyy-MM-dd", "en"),
      truck_category: "",
      truck_type: ""
    };

    this.services.SearchTruckDetails(payload).subscribe({
      next: (response: any) => {
        if (response && response.body) {
          const rawRoutes = [
            ...(response.body.data || []),
            ...(response.body.otherTruckType || [])
          ];
          if (rawRoutes.length > 0) {
            this.availableRoutes = rawRoutes.map((item: any) => {
              const fromCity = item.fromLocation?.from_city_name || item.fromLocation?.from_area_name || "Origin";
              const toCity = item.toLocation?.to_city_name || item.toLocation?.to_area_name || "Destination";
              const truckType = item.truck_type_name || (item.truck_weight ? `${item.truck_weight} ${item.truck_feet || ''}`.trim() : '') || item.make_name || "Truck";
              const truckCategory = item.truck_category_name || (item.truck_category === 'open' ? 'Open Truck' : 'Container') || 'Truck';
              const priceVal = item.price ?? item.route_fare ?? item.total_fare ?? 0;

              return {
                ...item,
                from: fromCity,
                to: toCity,
                truck_type_name: truckType,
                truck_category_name: truckCategory,
                available_trucks: item.available_trucks || 1,
                price: priceVal,
                driver_route_unique_id: item.driver_route_unique_id
              };
            });
          } else {
            this.availableRoutes = [];
          }
        }
      },
      error: (err: any) => {
        console.warn("Could not fetch available routes:", err);
      }
    });
  }

  reserveAvailableTrip(route: any) {
    this.token = sessionStorage.getItem("token") || sessionStorage.getItem("corporate_token");

    const dateVal = route.date ? new Date(route.date) : new Date();
    const categoryVal = route.truck_category_id || route.truck_category;
    const typeVal = route.truck_type_id || route.truck_type;

    let pickupFormatted = route.fromLocation?.from_area_name || route.fromLocation?.from_city_name || route.from || "";
    let dropFormatted = route.toLocation?.to_area_name || route.toLocation?.to_city_name || route.to || "";

    let fromAreaName = route.fromLocation?.from_area_name || pickupFormatted;
    let fromCityName = route.fromLocation?.from_city_name || pickupFormatted;
    let fromPincode = Number(route.fromLocation?.from_pincode) || 0;
    let fromLat = route.fromLocation?.from_lat || "";
    let fromLong = route.fromLocation?.from_long || "";

    let toAreaName = route.toLocation?.to_area_name || dropFormatted;
    let toCityName = route.toLocation?.to_city_name || dropFormatted;
    let toPincode = Number(route.toLocation?.to_pincode) || 0;
    let toLat = route.toLocation?.to_lat || "";
    let toLong = route.toLocation?.to_long || "";

    const fromLocation = {
      from_area_name: fromAreaName,
      from_city_name: fromCityName,
      from_pincode: fromPincode,
      from_lat: fromLat,
      from_long: fromLong,
    };

    const toLocation = {
      to_area_name: toAreaName,
      to_city_name: toCityName,
      to_pincode: toPincode,
      to_lat: toLat,
      to_long: toLong,
    };

    const tripSearchData: any = {
      fromLocation: fromLocation,
      toLocation: toLocation,
      date: route.date ? formatDate(route.date, "yyyy-MM-dd", "en") : formatDate(new Date(), "yyyy-MM-dd", "en"),
      truck_category: route.truck_category_id || route.truck_category || route.truck_category_name,
      truck_type: route.truck_type_id || route.truck_type || route.truck_type_name,
      completePickUpAddress: this.completePickUpAddress || { formatted_address: pickupFormatted },
      completeDropAddress: this.completeDropAddress || { formatted_address: dropFormatted },
      pickupPlace: this.pickupPlace || {
        formatted_address: pickupFormatted,
        name: fromCityName || fromAreaName || pickupFormatted
      },
      dropPlace: this.dropPlace || {
        formatted_address: dropFormatted,
        name: toCityName || toAreaName || dropFormatted
      },
      truckCategory: {
        id: route.truck_category_id || route.truck_category,
        name: route.truck_category_name || route.truck_category
      },
      truckweight: {
        _id: route.truck_type_id || route.truck_type,
        truck_weight: route.truck_weight || route.truck_type_name,
        truck_feet: route.truck_feet || ""
      },
      truckDetails: [route],
      selected_route: route
    };

    const fullResult = {
      data: [route],
      otherTruckType: [],
      searchData: tripSearchData
    };

    if (!this.token) {
      this.login("header");
    } else {
      this.coordinatesForm.controls["date"].setValue(dateVal);
      if (categoryVal) {
        this.coordinatesForm.controls["truck_category"].setValue(categoryVal);
        this.services.GettruckWeight(categoryVal).subscribe((response: any) => {
          if (response.status === 200) {
            this.truckWeight = (response.body.data || []).sort((a: any, b: any) => {
              let weightA = parseInt(a.truck_weight);
              let weightB = parseInt(b.truck_weight);
              return weightA - weightB;
            });
            this.filterWeight = this.truckWeight;
            if (typeVal) {
              this.coordinatesForm.controls["truck_type"].setValue(typeVal);
            }
          }
        });
      }

      this.coordinatesForm.controls["pickup"].setValue(pickupFormatted);
      this.coordinatesForm.controls["drop"].setValue(dropFormatted);
      
      sessionStorage.setItem("search_details", JSON.stringify(fullResult));
      sessionStorage.setItem("searchData", JSON.stringify(tripSearchData));
      sessionStorage.setItem("selectedId", route._id);

      this.shrdSrvce.updateSearchDetails(fullResult);
      this.router.navigateByUrl("/truck-details");
    }
  }

  viewAllRoutes() {
    this.showAllRoutes = !this.showAllRoutes;
  }
}
